import styled from "styled-components";

const Container = styled.div`
    width: 100%;
    display: flex;
    flex-grow: 1;
    max-height: 100%;
    flex-direction: column;
    align-items: center;
    align-content: center;
    justify-items: center;
    justify-content: center;
    background: white;
`;

export { Container };
